"use strict";

module.exports = function (str, searchStr) {
    return str.indexOf(searchStr) >= 0;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/objob/~/string-contains/index.js
 ** module id = 269
 ** module chunks = 0
 **/